export const NOTICE_HEADER = {
  title: '유의 사항을 꼭 확인해 주세요',
  description: '본 이벤트는 회사 사정으로 사전 고지 없이 변경 혹은 종료될 수 있습니다.',
}

export const NOTICE_SECTIONS = [
  {
    title: '참여 방법',
    items: [
      '본 이벤트 참여를 위해서는 이벤트/혜택 알림 동의가 필요합니다.',
      '경품 수령 목적으로 부당하게 이벤트에 참여할 경우 당첨이 취소될 수 있습니다.',
    ],
  },
  {
    title: '에너지 발급 정책',
    items: [
      '매일 00시 미션이 초기화됩니다.',
      '"수거신청을 통해 에너지 받기" : 수거신청 후 해당 수거신청 건이 결제가 완료되면 1개의 에너지가 지급됩니다.',
      '"공유하기를 통해 에너지 받기" : 내가 공유한 링크를 통해 앱을 설치했을 시 1개의 에너지가 지급됩니다.',
      '"퀴즈 풀고 에너지 받기" : 오늘수거와 관련한 퀴즈를 풀면 1개의 에너지가 지급됩니다.',
      '"공유하기를 통해 에너지 받기", "퀴즈 풀고 에너지 받기"는 하루에 한번만 참여할 수 있습니다.',
      '"퀴즈 풀고 에너지 받기"에서 퀴즈는 한 달에 총 10문제가 제공됩니다.',
    ],
  },
  {
    title: '당첨 확인',
    items: [
      '당첨 확인은 "오늘수거 앱"을 통해서만 가능합니다.',
      '지급받은 에너지는 익일 오후 11시 59분까지 사용할 수 있으며, 익일 오후 11시 59분까지 사용하지 않은 에너지는 소멸되어 복구 불가능합니다.',
    ],
  },
  {
    title: '당첨 혜택',
    items: [
      '당첨된 쿠폰은 쿠폰 당첨일 기준 14일간의 유효기간을 가집니다.',
      '당첨된 쿠폰의 유효기간은 연장이 불가능합니다.',
      '6번 연속 "플밍이가 찾은 100원 할인 쿠폰" 당첨 시 7번째 추첨에서는 더 높은 보상이 확정됩니다.',
      '1등 : 잭팟 상품',
      '2등 : 플밍이가 찾은 1만원 할인쿠폰',
      '3등 : 플밍이가 찾은 2,000원 할인쿠폰',
      '4등 : 플밍이가 찾은 1,000원 할인쿠폰',
      '5등 : 플밍이가 찾은 700원 할인쿠폰',
      '모두 : 플밍이가 찾은 100원 할인 쿠폰',
      '잭팟 상품은 매월 변경될 수 있습니다.',
      '잭팟 당첨자는 매월 1명 추첨으로 선정됩니다.',
      '해당 월에 1회 이상 쿠폰 찾기에 참여하면 자동으로 추첨대상이 됩니다.',
      '많이 참여할수록 당첨확률이 높아집니다.',
    ],
  },
  {
    title: '당첨자 정보 제출',
    items: [
      '잭팟 당첨자의 경우 오늘수거 회원 정보에 등록된 핸드폰 번호로 안내 문자가 발송 될 예정입니다.',
      '당첨자에게는 문자로 상세한 안내사항을 전달드립니다.',
      '5만원을 초과한 당첨금의 경우 제세공과금(22%)이 발생되며, 발생된 제세공과금은 당사에서 부담할 예정입니다.',
      '기간 내에 제출하지 않으면 당첨이 취소됩니다.',
      '수집된 정보는 세무 신고 완료 후 즉시 파기됩니다.',
    ],
  },
] as const
